import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { StorageService } from '../services/storage.service';
import { STORAGE_KEYS, UserRole, PERMISSION_ROUTE_MAP } from '../constants/app-constants';

export const dashboardGuard: CanActivateFn = () => {
  const storage = inject(StorageService);
  const router = inject(Router);

  const role = storage.get(STORAGE_KEYS.USER_ROLE);

  // Non-staff roles always have access to dashboard
  if (role !== UserRole.STAFF) return true;

  // Staff: check dashboard permission
  const permissions = storage.getJson<Record<string, boolean>>(STORAGE_KEYS.STAFF_PERMISSIONS) ?? {};
  if (permissions['dashboard'] === true) return true;

  // No dashboard permission — redirect to first permitted module
  for (const [key, allowed] of Object.entries(permissions)) {
    if (allowed && key !== 'dashboard' && PERMISSION_ROUTE_MAP[key]) {
      router.navigate([PERMISSION_ROUTE_MAP[key].route]);
      return false;
    }
  }

  // No permissions at all — go to profile
  router.navigate(['/profile']);
  return false;
};
